import React, { useCallback, useContext } from 'react';
import PropTypes from 'prop-types';
import _ from 'underscore';
import { withControlErrorHandling, withControlErrors } from '@bingads-webui-campaign-react/error-handling';
import { ServerContext } from '@bingads-webui-campaign-react/server-context';
import { withCustomValidation } from '@bingads-webui-react/validation';
import { ActivityContext } from '@bingads-webui-react/hoc-with-signal';
import { Label } from '@fluentui/react';
import { DefaultBid } from './default-bid';

const PriceModelToRange = {
  EnhancedCpc: 'KeywordBidRange',
  ManualCpc: 'KeywordBidRange',
  ManualCpv: 'KeywordCPVBidRange',
  ManualCpm: 'KeywordCPMBidRange',
};

const DefaultBidWithValidation = withControlErrorHandling(withControlErrors(DefaultBid));

const DefaultBidWithWaring = (props) => {
  const {
    onValidate, value, field, Type, label, ...rest
  } = props;

  const serverContext = useContext(ServerContext);
  const activity = useContext(ActivityContext);

  const onChange = useCallback((result) => {
    onValidate(result);

    if (activity) {
      activity.signal(`onDefaultBidChanged - ${field}: ${result && result.data && result.data[field]}`);
    }
  }, [activity, field, onValidate]);

  const getBidRange = useCallback((type) => {
    const bidCeil = _.result(serverContext[PriceModelToRange[type]], 'CeilingValue');
    const bidFloor = _.result(serverContext[PriceModelToRange[type]], 'FloorValue');

    return { bidCeil, bidFloor };
  }, [serverContext]);

  const { bidCeil, bidFloor } = getBidRange(Type);

  return (
    <>
      {label &&
      <Label htmlFor="input-bid">
        {label}
      </Label>
      }
      <DefaultBidWithValidation
        {...rest}
        currencyCode={serverContext.CurrentAccount.CurrencyCode}
        validationProps={{
          data: { [field]: value },
          field,
          schema: {
            properties: {
              [field]: {
                type: 'number',
                minimum: bidFloor,
                maximum: bidCeil,
                required: true,
              },
            },
          },
          onValidate: onChange,
        }}
      />
    </>
  );
};


DefaultBidWithWaring.propTypes = {
  Type: PropTypes.string,
  field: PropTypes.string.isRequired,
  onValidate: PropTypes.func,
  value: PropTypes.number,
  label: PropTypes.string,
};

DefaultBidWithWaring.defaultProps = {
  Type: 'EnhancedCpc',
  onValidate: _.noop,
  value: null,
  label: null,
};

export const ValidatedDefaultBid = withCustomValidation(DefaultBidWithWaring);

